<template>
    <a href="#" @click.prevent="showShareMenue"><icon icon="share-alt" :size="size"/></a>
</template>

<script>

    import Icon from "../Icon";

    export default {
        name: "share-post-button",
        props:{
            post: {default: Object},
            size: {type: String, default: '1x'}
        },
        computed: {

        },

        methods: {
            showShareMenue(){
                this.$bus.$emit('openShareModal', {post: this.post});
            },
        },
        components:{
            Icon
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/buttons/SharePostButton.vue